import axios from "axios";
import SignalContent from "../signal_content";
import { MstSignallampComponentType, SignallampStoreType, newSettingDataSetType } from "src/types/types";
import { RequestSignallampParamsMaker } from "./make_signallamp_request_params";
import { makeSendSignallampComponentSettingData, makeSendSignallampSettingData } from "./make_signallamp_setting_senddata";
import { applySetting, applySignallampSetting, checkSignallampSettingsThatMatchSelectDeviceId } from "./apply_setting";
import { getSignallampComponentSetting } from "./get_signallamp_component_setting";
import { getSignallampSetting } from "./get_signallamp_setting";
import { checkUpdateSignallampSettingData } from "./check_signallamp_setting";
import { checkComponentSettingData } from "./check_signallamp_component";

export async function updateAndGetAndApplyComponentSetting(self: SignalContent) {
  try {
    // 設定情報の保存し直し
    const updateData: MstSignallampComponentType = makeSendSignallampComponentSettingData(self);
    const checkResult = checkComponentSettingData(updateData);
    let result = false;
    if (checkResult) {
      alert(checkResult);
    } else {
      const requestParams = RequestSignallampParamsMaker.makeUpdateSignallampComponentSettingParams(
        updateData,
      );
      await axios(requestParams);
      result = true;
    }
    // 設定情報のとり直しとローカルに保存し直し
    const componentApiResponse = await getSignallampComponentSetting(self);
    applySetting(self, componentApiResponse);
    await getAndApplySetting(self);
    return result;
  } catch (e) {
    console.error(e);
  }
}

export async function updateAndGetAndApplySetting(self: SignalContent) {
  try {
    const newSettingDataSet: newSettingDataSetType = {
      addDeviceId: self.addDeviceId,
      addMails: self.addMails,
      newkeyColors: self.newkeyColors,
      alertCheck: self.alertCheck,
      mailSendInterval: self.mailSendInterval,
      addDbTable: self.addDbTable,
      addLocation: self.addLocation,
      userID: self.userID,
      authStoreName: self.authStoreName,
    };
    const checkResult = checkUpdateSignallampSettingData(newSettingDataSet);
    if (checkResult) {
      alert(checkResult);
      return false;
    } else {
      // フォームから更新用データの生成
      const updateData: SignallampStoreType = makeSendSignallampSettingData(newSettingDataSet, self.useAlertSound);
      // 設定情報保存処理用のリクエストデータ生成
      const requestParams = RequestSignallampParamsMaker.makeUpdateSignallampSettingParams(updateData);
      // 設定情報保存処理実行
      await axios(requestParams);
      await getAndApplySetting(self);
      return true;
    }
  } catch (e) {
    console.error(e);
  }
}

export async function getAndApplyComponentSetting(self: SignalContent) {
  const settingApiResponse = await getSignallampSetting(self);
  if (settingApiResponse) {
    self.mstSignallampSettings = settingApiResponse.data.res.mst_signallamp_setting;
    checkSignallampSettingsThatMatchSelectDeviceId(self);
    applySignallampSetting(self);
  }
  return settingApiResponse;
}

export async function getAndApplySetting(self: SignalContent) {
  const settingApiResponse = await getSignallampSetting(self);
  if (settingApiResponse) {
    self.mstSignallampSettings = settingApiResponse.data.res.mst_signallamp_setting;
    checkSignallampSettingsThatMatchSelectDeviceId(self);
    applySignallampSetting(self);
  }
  return settingApiResponse;
}
